import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import {
  Form,
  Message,
} from 'semantic-ui-react';
import _ from 'lodash';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import hasUserInfo from '../../hocs/has-user-info';

const messageStyles = {
  width: '100%',
};


const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const isValidEmail = email => {
  if (!_.isString(email) || _.isEmpty(email)) {
    return false;
  }
  return EMAIL_REGEX.test(email);
};

class MailoutTestModal extends Component {
  constructor(props) {
    super(props);
    const mailout = _.get(props, 'mailout', {});
    const email = _.get(props, 'userInfo.email', '');
    const name = _.get(props, 'userInfo.name', '');
    this.state = { email, name, errors: {}, ...mailout };
  }

  onInputChanged = async (event, rest) => {
    const { name, value, checked } = rest;
    this.setState({
      [name]: value || checked,
    });
  }

  handleFormSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;
    const {
      email,
      name,
      outreachEmailSubject,
      outreachEmailTemplate,
    } = this.state;
    this.setState({ errors: { name: null, email: null } });
    const isEmailValid = isValidEmail(email);
    const isNameValid = !_.isEmpty(name);
    if (isEmailValid && isNameValid) {
      onSubmit({ email, name, outreachEmailSubject, outreachEmailTemplate });
    } else {
      this.setState({
        errors: {
          email: isEmailValid ? null : 'Email is required',
          name: isNameValid ? null : 'Name is required',
        },
      });
    }
  }

  render() {
    const {
      onClose,
      isSubmitting,
      error,
      mailoutTestSuccess,
    } = this.props;

    const {
      email,
      name,
      errors,
      outreachEmailSubject,
      outreachEmailTemplate,
      utmSource,
    } = this.state;

    const isMailoutValid = !_.isEmpty(outreachEmailTemplate) && !_.isEmpty(outreachEmailTemplate);
    return (
      <div>
        <DyzioModal headerText="Test Mailout" size="small" onClose={onClose}>
          <div >
            {error && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Message
                  fluid
                  style={messageStyles}
                  icon="frown"
                  error
                  header="Error"
                  content={error}
                />
              </div>
            )}
            {mailoutTestSuccess && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Message
                  success
                  fluid
                  style={messageStyles}
                  icon="check circle outline"
                  header="Success"
                  content="Mailout sent successfully. Please check your email"
                />
              </div>
            )}

            <Form onSubmit={this.handleFormSubmit}>
              <div style={{ maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' }}>
                <Form.Field>
                  <label htmlFor="email">Email</label>
                  <Form.Input
                    placeholder="Enter email"
                    name="email"
                    id="email"
                    value={email}
                    onChange={this.onInputChanged}
                    error={Boolean(_.get(errors, 'email'))}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="name">Name</label>
                  <Form.Input
                    placeholder="Name"
                    name="name"
                    id="name"
                    value={name}
                    onChange={this.onInputChanged}
                    error={Boolean(_.get(errors, 'name'))}
                  />
                </Form.Field>
                <Form.Field
                  disabled error={_.isEmpty(outreachEmailTemplate)}
                >
                  <label htmlFor="emailSubject">Email Subject</label>
                  <Form.Input
                    placeholder="Missing email subject"
                    name="emailSubject"
                    id="emailSubject"
                    value={outreachEmailSubject || ''}
                  />
                </Form.Field>
                <Form.Field
                  disabled error={_.isEmpty(outreachEmailTemplate)}
                >
                  <label htmlFor="emailTemplate">Email Template</label>
                  <Form.Input
                    placeholder="Missing email template"
                    name="emailTemplate"
                    id="emailTemplate"
                    value={outreachEmailTemplate || ''}
                  />
                </Form.Field>
                <Form.Field
                  disabled error={_.isEmpty(outreachEmailTemplate)}
                >
                  <label htmlFor="utmSource">UTM Source</label>
                  <Form.Input
                    placeholder="Missing utm source"
                    name="utmSource"
                    id="utmSource"
                    value={utmSource || ''}
                  />
                </Form.Field>
              </div>
              <div
                className="flex"
                style={{
                  justifyContent: 'flex-end',
                  padding: '10px 0px 10px 0px',
                }}
              >
                <Form.Button
                  loading={isSubmitting}
                  disabled={isSubmitting || !isMailoutValid}
                  color="pink"
                  type="submit"
                  size="medium"
                >
                Submit
                </Form.Button>
              </div>
            </Form>

          </div>
        </DyzioModal>
      </div>
    );
  }
}

MailoutTestModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  error: PropTypes.any,
  mailoutTestSuccess: PropTypes.bool,
};
MailoutTestModal.defaultProps = {
  onClose: _.noop,
  onSubmit: _.noop,
  isSubmitting: false,
  error: null,
  mailoutTestSuccess: false,
};
export default compose(
  hasUserInfo,
)(MailoutTestModal);



/** WEBPACK FOOTER **
 ** ./src/components/mailout-test-modal/index.js
 **/